import {
  GET_OFFER_LIST_RESPONSE,
  ADD_OFFER_RESPONSE,
  UPDATE_OFFER_BY_OFFER_ID_RESPONSE,
  UPDATE_OFFER_STATUS_BY_OFFER_ID_RESPONSE,
  DELETE_OFFER_BY_OFFER_ID_RESPONSE,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  offerApiResponse: null,
  offerList: [],
  offerData: [],
  offerRecord: null,
};

const offerDetail = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_OFFER_LIST_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.offerData = response.responseData;
        } else {
          draft.offerData = [];
        }
        break;

      case ADD_OFFER_RESPONSE:
        draft.offerApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_OFFER_BY_OFFER_ID_RESPONSE:
        draft.offerApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_OFFER_STATUS_BY_OFFER_ID_RESPONSE:
        draft.offerApiResponse = action.payload.apiResponse;
        break;

      case DELETE_OFFER_BY_OFFER_ID_RESPONSE:
        draft.offerApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default offerDetail;
